<template>
  <div class="row collapsible-body">
    <h4 class="header col s12 light">Gérer ma réservation</h4>

    <div class="col s12" autocomplete="off">
      <div class="input-field col s12 m8 offset-m2">
        <input
          id="reference"
          placeholder="La référence est inscrite sur vos billets"
          minlength="8"
          type="text"
          v-on:input="resetError"
          v-model="code"
          class="validate"
        />
        <label for="reference">référence réservation</label>
        <span
          class="helper-text"
          data-error="Merci de vérifier la référence inscrite sur votre billet"
        ></span>
      </div>

      <div class="input-field col s12 m8 offset-m2">
        <input
          id="name"
          placeholder="Saisissez le nom de famille donné lors de la réservation"
          type="text"
          v-on:input="resetError"
          v-model="name"
          class="validate"
        />
        <label for="name">Nom de famille</label>
        <span
          class="helper-text"
          data-error="Merci de saisir le nom donnée durant la réservation"
        ></span>
      </div>
      <!-- <h4 style="color: red;text-align: center;">INDISPONIBLE POUR LE MOMENT!</h4> -->
      <div class="input-field col s12 center">
        <button id="connect" class="waves-effect waves-light btn">
          Rechercher
        </button>
      </div>
    </div>
    <p id="error" class="center darken-4 red-text">&nbsp;</p>
  </div>
</template>

<script>
import axios from "axios";
import jquery from "jquery";
import M from "materialize-css";
import API from "../api.js";
import qs from "qs";

export default {
  data() {
    return {
      // GT2100476 - BACAR
      // OF12QL - LARTIGUE
      // WB2100058 - YOUSSOUF
      // WB2200461 - SAID AHAMADI
      name: "",
      code: "",
    };
  },
  mounted() {
    // connect

    document.querySelector("#connect").addEventListener("click", (ev) => {
      ev.preventDefault();
      
      axios
        .post(
          API.reservation,
          qs.stringify({
            LastName: this.name,
            CodeReservation: this.code,
          })
        )
        .then((resp) => {
          // connexion failed
          console.log(resp);

          if (
            typeof resp.data !== "object" ||
            !("reservation" in resp.data) ||
            !("code" in resp.data.reservation) ||
            resp.data.reservation.code == ""
          ) {
            let msg = "Nous n'avons pas pu retrouver votre réservation !";

            jquery(this.$el).find("#error").html(msg).animate({ opacity: 1 });

            return;
          }

          // load reservation

          resp.data["name"] = this.name;

          this.$root.$emit("emit-reservation", resp.data);

          M.Collapsible.getInstance(jquery(".collapsible")).open(1);
          jquery("html, body").animate({ scrollTop: 0 });
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  methods: {
    resetError() {
      // jquery("#error").animate({ opacity: 0.1 }, function () {
      // jquery("#error").html("&nbsp;");
      // });
    },
  },
};
</script>


<style scoped>

  #error {
    opacity: 0.1; 
    pointer-events: none; /* Empêche les interactions avec l'élément */
  }
</style>